<template>
  <div class="page">
    <div class="wrap">
      <div class="card">
        <div class="Title">
          账号修改
          <span v-if="count !== -1"
            >（您本月账号修改的机会还剩{{ count }}次）</span
          >
        </div>
        <div class="notice">
          温馨提示：更换账号后，下次登录使用新账号登录。当前账号：<span>{{
            curAccount
          }}</span>
        </div>
        <div class="form">
          <a-form
            id="formUpdate"
            :form="form"
            ref="formUpdate"
            @submit="handleSubmit"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 8 }"
          >
            <div class="container">
              <input
                style="opacity: 0; position: absolute; width: 0; height: 0"
              />
              <input
                type="password"
                style="opacity: 0; position: absolute; width: 0; height: 0"
              />
              <a-form-item label="新账号">
                <a-input
                  class="cus-input"
                  type="text"
                  :maxLength="11"
                  autocomplete="off"
                  placeholder="请输入新的手机账号"
                  v-decorator="[
                    'accountNew',
                    {
                      rules: [
                        { required: true, message: '请输入新的手机账号' },
                      ],
                      validateTrigger: 'change',
                    },
                  ]"
                ></a-input>
              </a-form-item>

              <a-form-item label="验证码">
                <a-input
                  class="cus-input"
                  type="text"
                  autocomplete="off"
                  placeholder="请输入验证码"
                  :readonly="readOnly"
                  @click="
                    () => {
                      readOnly = false;
                    }
                  "
                  v-decorator="[
                    'vcode',
                    {
                      rules: [{ required: true, message: '请输入验证码' }],
                      validateTrigger: 'change',
                    },
                  ]"
                >
                  <a-button
                    type="link"
                    class="codeBtn"
                    slot="addonAfter"
                    :disabled="codeDisabled"
                    @click="sendCode"
                    >{{ btnText }}</a-button
                  >
                </a-input>
              </a-form-item>

              <div class="tipBg">
                账号修改的同时需进行密码重置，才能正常登录！
              </div>

              <a-form-item label="旧密码">
                <a-input
                  class="cus-input"
                  type="password"
                  autocomplete="off"
                  placeholder="请输入旧密码"
                  v-decorator="[
                    'password',
                    {
                      rules: [{ required: true, message: '请输入旧密码' }],
                      validateTrigger: 'change',
                    },
                  ]"
                ></a-input>
              </a-form-item>

              <a-form-item label="新密码">
                <a-input
                  class="cus-input"
                  type="password"
                  autocomplete="off"
                  placeholder="请输入新密码"
                  v-decorator="[
                    'passwordNew',
                    {
                      rules: [{ required: true, message: '请输入新密码' }],
                      validateTrigger: 'change',
                    },
                  ]"
                ></a-input>
              </a-form-item>

              <a-form-item label="确认密码">
                <a-input
                  class="cus-input"
                  type="password"
                  autocomplete="off"
                  placeholder="请再次输入密码"
                  v-decorator="[
                    'psdAgain',
                    {
                      rules: [{ required: true, message: '请再次输入密码' }],
                      validateTrigger: 'change',
                    },
                  ]"
                ></a-input>
              </a-form-item>

              <a-form-item :wrapper-col="{ span: 15, offset: 8 }">
                <div class="tip">{{ tip }}</div>
              </a-form-item>

              <a-form-item :wrapper-col="{ span: 8, offset: 8 }">
                <a-button
                  type="primary"
                  size="large"
                  block
                  htmlType="submit"
                  class="action-button"
                  >确认修改</a-button
                >
              </a-form-item>
            </div>
          </a-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCurAccount,
  updateAccount,
  updateAccountCode,
  getAccountNum,
  updatePwd,
  updatePwdRule,
  logOut,
} from "@/api/api";
import { telValid } from "@/utils/reg.js";

export default {
  name: "updatePwd",
  data() {
    return {
      form: this.$form.createForm(this),
      btnText: "获取验证码",
      codeDisabled: false,
      rule: "",
      tip: "",
      prompt: "",
      count: "", // 账号修改次数   code 为 -1 时，表示未配置修改次数
      sid: "",
      curAccount: "", // 当前账号
      phone: "",
      readOnly: true,
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!values.accountNew) {
          this.$message.error("请填写手机号");
          return;
        } else {
          if (!telValid(values.accountNew.trim())) {
            this.$message.error("请填写正确格式的手机号码");
            return;
          }
        }
        if (values.accountNew == this.curAccount) {
          this.$message.error("您输入的账号和当前账号相同，请重新输入！");
          return;
        }
        if (values.passwordNew) {
          const regPwd = eval(`/${this.rule}/`);
          if (!regPwd.test(values.passwordNew)) {
            this.$message.error({
              content: this.prompt,
            });
            return;
          }
        }
        if (values.passwordNew && values.password) {
          if (values.password == values.passwordNew) {
            this.$message.error("新密码需与旧密码不同！");
            return;
          }
        }
        if (values.psdAgain) {
          if (values.psdAgain != values.passwordNew) {
            this.$message.error("两次输入密码不一致，请重新输入！");
            return;
          }
        }

        if (!err) {
          updateAccount({
            accountNew: values.accountNew.trim(),
            vcode: values.vcode.trim(),
            password: values.password.trim(),
            passwordNew: values.passwordNew.trim(),
            sCode: localStorage.getItem("sCode"),
          }).then((res) => {
            if (res.code == 0) {
              this.form.resetFields();
              // this.$message.success(res.msg)
              this.toLogout();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    toLogout() {
      const _this = this;
      this.$confirm({
        title: "提示",
        content: "账号修改成功，请使用新账号新密码进行登录！",
        onOk() {
          logOut().then((res) => {
            if (res.code == 0) {
              // _this.$message.success(res.msg);
              // _this.$message.success('注销登录成功');
              const uvCode = localStorage.getItem("uvCode");
              localStorage.clear();
              setTimeout(() => {
                _this.$router.push({
                  name: "Login",
                  query: {
                    uvCode: uvCode,
                  },
                });
              }, 1000);
            } else {
              _this.$message.error(res.msg);
            }
          });
        },
        onCancel() {},
      });
    },
    // 发送验证码
    sendCode() {
      this.phone = this.form.getFieldValue("accountNew");
      if (!this.phone) {
        this.$message.error("请填写手机号");
        return;
      } else {
        if (!telValid(this.phone.trim())) {
          this.$message.error("请填写正确格式的手机号码");
          return;
        }
      }
      if (this.phone == this.curAccount) {
        this.$message.error("您输入的账号和当前账号相同，请重新输入！");
        return;
      }
      this.codeDisabled = true;
      updateAccountCode({
        phone: this.phone.trim(),
        uvCode: localStorage.getItem("uvCode"),
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          var time = 60; // 定义60秒的倒计时
          const _this = this;
          var codeV = setInterval(function () {
            _this.btnText = `重新获取${--time}s`;
            if (time == -1) {
              // 清除setInterval倒计时，按钮变回原样
              clearInterval(codeV);
              _this.codeDisabled = false;
              _this.btnText = "获取验证码";
            }
          }, 1000);
        } else {
          this.codeDisabled = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取密码规则
    getPwdRule() {
      updatePwdRule().then((res) => {
        this.rule = res.regular;
        this.tip = res.pwdZcText;
        this.prompt = res.prompt;
      });
    },
    // 获取当前账号
    // getAccount () {
    //   getCurAccount().then(res => {
    //     this.curAccount = res.username;
    //   })
    // },
    // 获取修改剩余次数
    getCount() {
      getAccountNum({
        id: this.sid,
      }).then((res) => {
        this.count = res.data;
      });
    },
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem("user"));
    if (userInfo) {
      this.curAccount = userInfo.loginname;
      this.sid = userInfo.sid;
    }
    this.form.resetFields();
    // this.getAccount()
    this.getPwdRule();
    this.getCount();
  },
};
</script>

<style lang="less" scoped>
.page {
  background-color: #f5f5f5;
}
.wrap {
}
/deep/ .ant-input-group-addon {
  background-color: #fff;
}
.codeBtn {
  padding: 0 4px;
  background-color: #fff;
  height: 30px;
}
.card {
  background-color: #ffffff;
  min-height: 448px;
  border-radius: 4px;
  padding: 0 20px;
  .Title {
    padding: 16px 0 12px;
    border-bottom: 1px solid #f5f5f5;
    font-size: 16px;
    color: #000000;
    font-weight: 600;
    span {
      font-size: 14px;
      color: #ff4747;
      font-weight: normal;
    }
  }
  .notice {
    font-size: 14px;
    color: #666;
    margin-top: 16px;
    span {
      color: #333;
    }
  }
  .form {
    margin-top: 40px;
  }
  .action-button {
    margin-bottom: 56px;
  }
}
.tip {
  font-size: 12px;
  color: #ff4747;
}
.tipBg {
  font-size: 12px;
  color: #ff4747;
  text-align: center;
  width: 380px;
  line-height: 28px;
  background: #fff6f6;
  border-radius: 4px;
  margin: 4px 0px 26px 246px;
}
</style>
